import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Tag } from 'lucide-react';
import { TrendingUp } from 'lucide-react';
import { Users } from 'lucide-react';
import { Calendar } from 'lucide-react';
import { DiscountCodeZ as DiscountCode } from '@libs/schemas';
import { trpc } from 'src/trpc';

export const DiscountStatistics = ({
  discountCodes,
  total,
}: {
  discountCodes: DiscountCode[];
  total: number;
}) => {
  const totalCodes = total;
  const activeCodes = discountCodes.filter(
    (code) => code.active && new Date(code.expiresAt) > new Date(),
  ).length;
  const { data: totalUses } = trpc.admin.discountCodes.getTotalDiscountCodeUsages.useQuery();
  const expiredCodes = discountCodes.length - activeCodes;

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Total Codes</CardTitle>
          <Tag className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{totalCodes}</div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Active Codes</CardTitle>
          <TrendingUp className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-green-600">{activeCodes}</div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Total Uses</CardTitle>
          <Users className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-blue-600">{totalUses ?? 0}</div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Expired Codes</CardTitle>
          <Calendar className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-red-600">{expiredCodes}</div>
        </CardContent>
      </Card>
    </div>
  );
};
